import viteLogo from "/skills-icon/vite.svg";
import htmlLogo from "/skills-icon/html5.svg";
import javascriptLogo from "/skills-icon/javascript.svg";
import nextjsLogo from "/skills-icon/nextjs.svg";
import reactLogo from "/skills-icon/react.svg";
import sassLogo from "/skills-icon/sass.svg";
import typescriptLogo from "/skills-icon/typescript.svg";
import webpackLogo from "/skills-icon/webpack.svg";

const skillsData= [
  {
    src: javascriptLogo,
    alt: 'JavaScript'
  },
  {
    src: htmlLogo,
    alt: 'HTML5'
  },
  {
    src: typescriptLogo,
    alt: 'TypeScript'
  },
  {
    src: sassLogo,
    alt: 'SCSS'
  },
  {
    src: reactLogo,
    alt: 'React.js'
  },
  {
    src: webpackLogo,
    alt: 'Webpack'
  },
  {
    src: viteLogo,
    alt: 'Vite'
  },
  {
    src: nextjsLogo,
    alt: 'Next.js'
  }
];

export default skillsData;